module.exports = __webpack_public_path__ + "media/images/refresh-c9541c18bcd2d1ac418ec2a0c2b344a7.png";